import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { paymentTypeTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const editPaymentType = (
  data: paymentTypeTypes.EditPaymentTypeData
): Promise<{ paymentType: paymentTypeTypes.PaymentType }> => {
  const { _id, ...dataWithoutId } = data;
  return axios.patch(`/payment-types/${_id}`, { data: dataWithoutId });
};

type EditPaymentTypeOptions = {
  onSuccess: () => void;
  config?: MutationConfig<typeof editPaymentType>;
};

export function useEditPaymentType({ config = {}, onSuccess }: EditPaymentTypeOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['payment-types']);
      toasts.loadingToast.success('edit-payment-type', 'Payment type updated successfully');
      onSuccess();
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('edit-payment-type', serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('edit-payment-type', 'Updating payment type...');
      config.onMutate?.(...args);
    },
    mutationFn: editPaymentType,
  });
}
